import React from 'react';
import { IAdsCopilotProps } from '../../types';

export interface ILoadingContextValue {
  onReceiveActivity: NonNullable<IAdsCopilotProps['onReceiveActivity']>;
  renderBottomComponent: NonNullable<IAdsCopilotProps['renderBottomComponent']>;
  isGeneratingAnswer: boolean;
  isTroubleshooting: boolean;
  onClickStopGenerating: () => void;
  onClickStopTroubleshooting: () => void;
  isLiveAgentInProgress?: boolean;
  onEndLiveAgentChatClick?: () => void;
}

export const LoadingContext = React.createContext<ILoadingContextValue | null>(null);
